import React from 'react'
import { DateScroll } from '@/components/donation'
import { SubSection } from '../styled.jsx'

export const DateScrollSection = () => {
  return (
    <SubSection
      title='Date Scroll'
      description='Scrollable date chips centered on today'
    >
      <DateScroll id='playground-donation-picker' data={[]} />
    </SubSection>
  )
}
